import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';

import styles from './SocketStatus.module.scss';

const SocketStatus = React.memo(({ alerts, alertDisplayed, updateAlerts, isDisconnected }) => {
  const [t] = useTranslation();
  useEffect(() => {
    if (alerts[0]?.alertSettingId) {
      const timer = setTimeout(() => {
        if (alertDisplayed === false) {
          updateAlerts();
        }
      }, 5000);
      return () => clearTimeout(timer);
    }
    return () => {};
  }, [alerts, alertDisplayed, updateAlerts]);

  if (isDisconnected) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.header}>{t('common.noConnectionToServer')}</div>
        <div className={styles.content}>
          <Trans i18nKey="common.allChangesWillBeAutomaticallySavedAfterConnectionRestored">
            All changes will be automatically saved
            <br />
            after connection restored
          </Trans>
        </div>
      </div>
    );
  }

  if (!alertDisplayed) {
    return (
      <div
        className={`${styles.wrapper} ${styles.wrapper_alerts} ${
          alerts[0].resTime !== null ? styles.wrapper_fixed : ''
        }`}
      >
        <div className={styles.header}>
          {alerts[0].resTime === null ? t('common.haveNewAlert') : t('common.problemHasBeenFixed')}
        </div>
        <div className={styles.content}>
          <span className={styles.content_device}>
            {`${alerts[0]?.device?.name} - ${alerts[0]?.item?.name} - ${alerts[0]?.alertSetting?.name}`}
          </span>
        </div>
      </div>
    );
  }

  return null;
});

SocketStatus.propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.any).isRequired,
  alertDisplayed: PropTypes.bool.isRequired,
  isDisconnected: PropTypes.bool.isRequired,
  updateAlerts: PropTypes.func.isRequired,
};

export default SocketStatus;
